<template>
    <div class="cookie-policy" :class="[$store.state.cookies === true ? 'hidden' : '']">
        <div class="cookie-policy-wrapper cookie-color-1">
            <div class="cookie-text">
                <span>{{ getSnippets('Cookies') }}</span>
            </div>
            <button type="button" class="cookie-button" @click="setCookies(true)">
                <span class="line line1"></span>
                <span class="line line2"></span>
            </button>
        </div>
    </div>
</template>

<script>
    /* Mixins */
    import { Default } from '../../../mixins/Default'

    /* Logic */
    export default {
        name: "Cookies",
        mixins: [Default],
        props: [
            'currency',
            'locality',
            'snippets',
            'translatable',
        ],
        mounted() {
            setTimeout( () => {
                this.setCookies(true);
            }, 8000)
        },
        created: function () {
            this.initialize()
        }
    }
</script>